document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.regular-shipping-wrapper');
  if (!wrapper) return;
  
  const buttons = wrapper.querySelectorAll('.regular-shipping-btn');
  const pickupDropdown = wrapper.querySelector('.regular-pickup-dropdown');
  const locationSelect = wrapper.querySelector('#regular-pickup-location');
  const completeMessage = wrapper.querySelector('.regular-shipping-complete-message');
  
  const priceEl = document.querySelector('.price__regular .price-item--regular') || 
                  document.querySelector('.product__price') ||
                  document.querySelector('[data-product-price]');
  
  const buttonPriceEl = document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');
  
  const basePrice = parseFloat(wrapper.dataset.basePrice) || 0;
  const deliveryRate = parseFloat(wrapper.dataset.deliveryRate) || 0;
  
  // Helper to safely extract numeric variant ID from string or GID
  function toVariantId(raw) {
    if (!raw) return null;
    const str = String(raw).trim();
    const match = str.match(/(\d+)\s*$/);
    return match ? parseInt(match[1], 10) : null;
  }
  
  const deliveryVariantId = toVariantId(wrapper.dataset.deliveryVariantId);
  
  let isShipping = null;
  
  const productForm = document.querySelector('form[action="/cart/add"]') ||
                      document.querySelector('product-form form') ||
                      document.querySelector('.product-form form');
  
  // Better button selector - targets actual button element
  const addToCartBtn =
    (productForm ? productForm.querySelector('button[type="submit"], button[name="add"]') : null) ||
    document.querySelector('form[action="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[type="submit"], button[name="add"]');
  
  // Dynamic ATC label helpers
  let originalAtcHTML = addToCartBtn ? addToCartBtn.innerHTML : '';
  
  function setAtcLockedLabel(message) {
    if (!addToCartBtn) return;
    addToCartBtn.innerHTML = message || 'Select delivery method';
    addToCartBtn.setAttribute('aria-disabled', 'true');
  }
  
  function setAtcUnlockedLabel() {
    if (!addToCartBtn) return;
    if (!originalAtcHTML) originalAtcHTML = addToCartBtn.innerHTML;
    addToCartBtn.innerHTML = originalAtcHTML;
    addToCartBtn.removeAttribute('aria-disabled');
  }
  
  // Initial disabled state
  if (addToCartBtn) {
    addToCartBtn.style.opacity = '0.5';
    addToCartBtn.style.pointerEvents = 'none';
    setAtcLockedLabel('Select delivery method');
  }
  
  function checkCompletion() {
    let isComplete = false;
    
    if (isShipping === true) {
      isComplete = true;
    } else if (isShipping === false) {
      isComplete = locationSelect && locationSelect.value !== '';
    }
    
    if (addToCartBtn) {
      if (isComplete) {
        addToCartBtn.style.opacity = '1';
        addToCartBtn.style.pointerEvents = 'auto';
        setAtcUnlockedLabel();
      } else {
        addToCartBtn.style.opacity = '0.5';
        addToCartBtn.style.pointerEvents = 'none';
        // Contextual locked text
        if (isShipping === false) {
          setAtcLockedLabel('Select pickup location');
        } else {
          setAtcLockedLabel('Select delivery method');
        }
      }
    }
    
    if (completeMessage) {
      completeMessage.style.display = isComplete ? 'flex' : 'none';
    }
    
    return isComplete;
  }
  
  function updatePrice() {
    let total = basePrice;
    if (isShipping === true) {
      total += deliveryRate;
    }
    
    const formattedPrice = '$' + total.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    
    if (priceEl) {
      priceEl.textContent = formattedPrice;
    }
    
    if (buttonPriceEl) {
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + formattedPrice;
    }
  }
  
  function updateVisibility() {
    if (pickupDropdown) {
      pickupDropdown.style.display = (isShipping === false) ? 'block' : 'none';
    }
  }
  
  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      buttons.forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      
      isShipping = this.dataset.option === 'shipping';
      
      if (locationSelect) locationSelect.value = '';
      
      updateVisibility();
      updatePrice();
      checkCompletion();
    });
  });
  
  if (locationSelect) {
    locationSelect.addEventListener('change', function() {
      checkCompletion();
    });
  }
  
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      if (!checkCompletion()) {
        if (isShipping === null) {
          alert('Please select a shipping option.');
        } else {
          alert('Please select a pickup location.');
        }
        return;
      }
      
      // Null guard on productForm
      if (!productForm) {
        alert('Error: Could not find product form.');
        return;
      }
      
      const mainVariantInput = productForm.querySelector('input[name="id"]') || 
                                productForm.querySelector('select[name="id"]');
      const mainVariantId = toVariantId(mainVariantInput ? mainVariantInput.value : null);
      
      if (!mainVariantId) {
        alert('Error: Could not find product variant.');
        return;
      }
      
      const quantityInput = document.querySelector('input[name="quantity"]') || 
                            document.querySelector('.quantity-input input') ||
                            document.querySelector('.quantity__input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      
      const items = [];
      
      const mainItem = {
        id: mainVariantId,
        quantity: quantity,
        properties: {
          'Shipping Method': isShipping ? 'Flat Rate Shipping' : 'Warehouse Pickup'
        }
      };
      
      if (!isShipping && locationSelect) {
        mainItem.properties['Pickup Location'] = locationSelect.value;
      }
      
      items.push(mainItem);
      
      if (isShipping && deliveryVariantId) {
        items.push({ id: deliveryVariantId, quantity: quantity });
      }
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) {
            throw new Error(data.description || 'Cart add failed');
          });
        }
        return response.json();
      })
      .then(function(data) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        
        const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
        if (cartIcon) {
          cartIcon.click();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        alert('Error adding to cart: ' + error.message);
      });
    }, true);
  }
  
  updateVisibility();
  updatePrice();
  checkCompletion();
});
